// extracted by mini-css-extract-plugin
export default {"root":"root--OAap6","controls":"controls--Y3OMS","footer":"footer--Rgzyg","container":"container--EZK1U","ghost":"ghost--Uzdti","disabled":"disabled--fY3fD","item":"item--ZghSq"};